// pricebook.art.get's answer (BL-109), as its view reads it: a price book item's house-style drawing, light
// and dark, what it shows and how many items share it (items that look alike share one picture), the
// newest making's state in words, and whether this person may ask for a new one. Only
// pictures that passed their check are `live`; `next` carries a picture that hasn't only for those who
// edit the price book. 'proposed' is a close match from Flowology's picture library waiting for a person
// to use it or make a new one (pricebook.art.answerMatch); 'to_approve' a new one that passed its check,
// waiting for the owner or a manager to approve it (BL-122). services/api's ui-contract test parses the
// real answer with this.
import { z } from 'zod';

const Id = z.string().min(1);

export const ArtRef = z.object({
  artId: Id,
  url: z.string().nullable(),
  thumbUrl: z.string().nullable(),
  styleVersion: z.string(),
  madeAt: z.string(),
});
export type ArtRef = z.infer<typeof ArtRef>;

export const ArtVersion = z.object({
  artId: Id,
  status: z.enum([
    'queued',
    'making',
    'checking',
    'proposed',
    'to_approve',
    'passed',
    'failed',
    'needs_a_person',
    'retired',
  ]),
  attempt: z.number().int(),
  why: z.string().nullable(),
  url: z.string().nullable(),
});

export const ArtSubject = z.object({
  id: Id,
  words: z.string(),
  look: z.enum(['drawing', 'label']),
  sharedBy: z.number().int(),
  chosenBy: z.enum(['rule', 'derived', 'person']),
  own: z.boolean(),
});

export const ART_STATES = [
  'off',
  'none',
  'naming',
  'making',
  'checking',
  'ready',
  'needs_a_look',
  'proposed',
  'to_approve',
  'paused',
  'refused',
  'failed',
] as const;

export const PricebookArtProps = z.object({
  itemId: Id,
  enabled: z.boolean(),
  state: z.enum(ART_STATES),
  words: z.string(),
  canRequest: z.boolean(),
  live: z.object({ light: ArtRef.nullable(), dark: ArtRef.nullable() }),
  /** what its picture shows, and how many items share it; null until it's worked out */
  subject: ArtSubject.nullable(),
  next: z.object({ light: ArtVersion.nullable(), dark: ArtVersion.nullable() }).nullable(),
  request: z.string().nullable(),
  why: z.string().nullable(),
  /** what a new pair costs about, in cents: only for those who see cost */
  estimateCents: z.number().nullable().optional(),
});
export type PricebookArtProps = z.infer<typeof PricebookArtProps>;
